















import type {PeriodeMetOpdrachten} from "../../types/opdrachten/PeriodeMetOpdrachten";

import Vue from "vue";
import OpdrachtCardContent from "./OpdrachtCardContent.vue";
import EhrCard from "./EhrCard.vue";
import SectionCard from "../interface/SectionCard.vue";
import {PeriodeIcon} from "./periode-icon";
import PeriodeMetOpdrachtenVolumes from "./PeriodeMetOpdrachtenVolumes.vue";

const periodeIcons: {[key: string]: PeriodeIcon} = {
  'Verleden': 'chevrons-left',
  'Heden': 'tasks',
  'Toekomst': 'chevrons-right',
};

export default Vue.extend({
  name: "PeriodeMetOpdrachten",
  components: {
    SectionCard,
    EhrCard,
    OpdrachtCardContent,
    PeriodeMetOpdrachtenVolumes,
  },
  props: {
    periodeMetOpdrachten: {
      type: Object as () => PeriodeMetOpdrachten,
      required: true,
    },
  },
  computed: {
    title(): string {
      const { van, tot } = this.periodeMetOpdrachten.periode;
      if (!tot) return `Vanaf ${van}`;
      return van === tot ? van : `${van} - ${tot}`;
    },
    icon(): PeriodeIcon {
      const { chronologie } = this.periodeMetOpdrachten.periode;
      return periodeIcons[chronologie];
    },
  },
});
